module.exports = __webpack_public_path__ + "media/src/assets/Images/MessageEdit-1a6f6f75aeddcea6274d395b145833a0.svg";